import { FooterStyled } from "../styles/footer";
import {
  FaFacebookF,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

export const Footer = ({ relative }) => {
  return (
    <FooterStyled relative={relative}>
      <span>Copyright © ACLS Tecnologia 2024</span>
      <ul>
        <li>
          <a href="https://api.whatsapp.com/send?phone=+55(62)%203577-1553&text=Teste" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/aclstecnologia" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
        </li>
        <li>
          <a href="https://br.linkedin.com/company/aclsconnect" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
        </li>
        <li>
        <a href="https://www.youtube.com/channel/UCxWo2TsHhQLewOVXDH6TrqQ" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        </li>
        <li>
        <a href="https://www.youtube.com/channel/UCxWo2TsHhQLewOVXDH6TrqQ" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
        </li>
      </ul>
    </FooterStyled>
  );
};
